import React, { createContext, useContext } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { classicTheme, bloombergTheme } from '../theme';
import { useLocalStorage } from "@uidotdev/usehooks";

export const THEME_TYPE_CLASSIC = 'classic';
export const THEME_TYPE_BLOOMBERG = 'bloomberg';

export type ThemeType = typeof THEME_TYPE_CLASSIC | typeof THEME_TYPE_BLOOMBERG;

interface ThemeContextType {
    currentTheme: ThemeType;
    setTheme: (theme: ThemeType) => void;
}

const ThemeContext = createContext<ThemeContextType>({
    currentTheme: THEME_TYPE_CLASSIC,
    setTheme: () => {},
});

const LOCAL_STORAGE_KEY = 'conveyor_belt_wealth_theme';

export const useThemeContext = () => useContext(ThemeContext);

export const ThemeContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [currentTheme, setCurrentTheme] = useLocalStorage<ThemeType>(LOCAL_STORAGE_KEY, THEME_TYPE_CLASSIC);

    const theme = currentTheme === THEME_TYPE_CLASSIC ? classicTheme : bloombergTheme;

    return (
        <ThemeContext.Provider value={{ currentTheme, setTheme: setCurrentTheme }}>
            <MuiThemeProvider theme={theme}>
                {children}
            </MuiThemeProvider>
        </ThemeContext.Provider>
    );
}; 